export default class TourFaqModel {
    tourId: number = 0
    index: number = 0
    question: string = ""
    answer: string = ""
}